import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-blog-cover',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="cover" [style.--cover-ratio]="ratio">
      <div class="halftone" aria-hidden="true"></div>
      <div class="glow" aria-hidden="true"></div>

      <div class="top">
        <img
          class="logo"
          src="/logo/adradar-logo.svg"
          alt="adRadar"
        />
      </div>
      <div class="rule" aria-hidden="true"></div>

      <div class="center">
        <h3 class="title">{{ title }}</h3>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        container-type: inline-size;
      }

      .cover {
        position: relative;
        width: 100%;
        aspect-ratio: var(--cover-ratio, 16 / 10);
        overflow: hidden;
        border-radius: 14px;
        padding: 1.1rem 1.35rem 1.2rem;
        display: flex;
        flex-direction: column;
        isolation: isolate;
        color: #1a1a2e;
        background:
          radial-gradient(
            120% 80% at 20% 0%,
            #ffece2 0%,
            transparent 55%
          ),
          radial-gradient(
            120% 90% at 90% 100%,
            #fcd6c4 0%,
            transparent 55%
          ),
          linear-gradient(135deg, #ffe4d6 0%, #ffd2be 100%);
        border: 1px solid rgba(232, 87, 58, 0.18);
        transition:
          transform 0.3s ease,
          box-shadow 0.3s ease;
        box-shadow: 0 2px 14px -4px rgba(232, 87, 58, 0.15);
      }

      :host(:hover) .cover {
        transform: translateY(-2px);
        box-shadow: 0 16px 40px -16px rgba(232, 87, 58, 0.3);
      }

      /* Halftone dot texture — factors.ai-style print feel */
      .halftone {
        position: absolute;
        inset: 0;
        z-index: -1;
        background-image: radial-gradient(
          circle at 1px 1px,
          rgba(232, 87, 58, 0.18) 1px,
          transparent 0
        );
        background-size: 6px 6px;
        opacity: 0.75;
        mask-image: linear-gradient(
          135deg,
          rgba(0, 0, 0, 0.9) 0%,
          rgba(0, 0, 0, 0.4) 55%,
          rgba(0, 0, 0, 0.8) 100%
        );
        -webkit-mask-image: linear-gradient(
          135deg,
          rgba(0, 0, 0, 0.9) 0%,
          rgba(0, 0, 0, 0.4) 55%,
          rgba(0, 0, 0, 0.8) 100%
        );
      }

      /* Soft warm glow — adds depth */
      .glow {
        position: absolute;
        width: 80%;
        height: 80%;
        top: -30%;
        right: -20%;
        border-radius: 50%;
        background: radial-gradient(
          circle,
          rgba(255, 210, 180, 0.5) 0%,
          transparent 65%
        );
        filter: blur(30px);
        z-index: -1;
        pointer-events: none;
      }

      .top {
        display: flex;
        align-items: center;
      }

      .logo {
        height: 22px;
        width: auto;
        display: block;
      }

      .rule {
        height: 1px;
        background: rgba(26, 26, 46, 0.18);
        margin: 0.7rem 0 0.85rem;
      }

      .center {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        min-height: 0;
        overflow: hidden;
      }

      .title {
        margin: 0;
        font-size: clamp(1rem, 5.5cqi, 2rem);
        font-weight: 700;
        line-height: 1.18;
        letter-spacing: -0.025em;
        color: #1a1a2e;
        text-wrap: balance;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        width: 100%;
      }
    `,
  ],
})
export class BlogCoverComponent {
  @Input({ required: true }) title!: string;
  @Input() slug = '';
  @Input() ratio: string = '16 / 10';
}
